import { render, staticRenderFns } from "./TestAccountLinks.vue?vue&type=template&id=0c070327&lang=pug"
import script from "./TestAccountLinks.vue?vue&type=script&lang=js"
export * from "./TestAccountLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports